import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ensureDefined, } from '@tymia/shared';
import { DateTime, } from 'luxon';
import { useEffect, useState, } from 'react';
import { useParams, } from 'react-router-dom';
import { api, } from '../../api/Api.js';
import { BookingComponent, } from './BookingComponent.js';
export function BookingWidget() {
    const { userId } = useParams();
    const therapistId = Number(ensureDefined(userId));
    const [apiResponse, setApiResponse] = useState();
    useEffect(() => {
        let isMounted = true;
        void (async () => {
            const response = await api.client.appointment.bookable.request({
                therapistId,
                startDate: DateTime.now()
                    .startOf('week').toISO(),
            });
            if (isMounted && response.status === 'ok') {
                setApiResponse(response);
            }
        })();
        return () => {
            isMounted = false;
        };
    }, []);
    if (!apiResponse) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(BookingComponent, { ...apiResponse, therapistId: therapistId }));
}
//# sourceMappingURL=BookingWidget.js.map